import {
  params,
  string,
  number,
  bool,
  shape,
  extend,
  arrayOf
} from '@thd-nucleus/data-sources';
import { CustomProductPod } from './components/ProductPodContainer/CustomProductPod';

// TODO: Add this below itemId: string() once https://thd.atlassian.net/browse/AI-1386 is done
// availabilityType: shape({
//   buyable: bool(),
//   discontinued: bool(),
//   status: bool(),
//   type: string(),
// }),
const Product = extend({
  dataSources: string(),
  itemId: string(),
  identifiers: shape({
    itemId: string(),
    canonicalUrl: string(),
    productLabel: string(),
    brandName: string(),
    modelNumber: string(),
    productType: string(),
  }),
  info: shape({
    label: string(),
    productGroup: string(),
  }),
  media: shape({
    images: arrayOf({
      subType: string(),
      url: string(),
      type: string(),
      sizes: arrayOf(string())
    }),
    image: shape({
      url: string()
    }).client(),
  }),
  reviews: shape({
    ratingsReviews: shape({
      averageRating: number(),
      totalReviews: number()
    })
  }),
  pricing: params({ storeId: string() }).shape({
    value: number(),
    mapAboveOriginalPrice: bool(),
    promotionalAdjustments: shape({
      type: string(),
      description: shape({
        shortDesc: string(),
        longDesc: string()
      }),
      dollarOff: number({ float: true }),
      percentageOff: number({ float: true }),
      promoId: string(),
    }),
    mapDetail: shape({
      mapPolicy: string(),
      percentageOff: number({ float: true }),
      dollarOff: number({ float: true }),
      mapSpecialPriceViolation: bool(),
      mapOriginalPriceViolation: bool()
    })
  })
},
CustomProductPod.dataModel.product
);

export const dataModel = extend({
  products: params({ itemIds: arrayOf(string().isRequired()).isRequired(), dataSource: string() })
    .arrayOf(Product),
  product: Product
},
);
